// type safe paths
// https://github.com/garybernhardt/static-path
//
// tip: unless you're adding the route to the router, always call these as a
// function even if they don't take parameters
// e.g.  <Link to={rootPath({})}> and not <Link to={rootPath.pattern}>
import { path } from "static-path"

export const rootPath = path("/")
export const loginPath = path("/login")
export const detailsPath = path("/details")
export const dashboardPath = path("/dashboard")
export const profilePath = path("/profile")
export const profileEditPath = path("/profile/edit")
export const internalAdminDashboardPath = path("/internal-admin/dashboard")

export const sourceReactionPath = path("/reactions/:sourceId")
export const newIdeaPath = path("/ideas/new")
export const postPath = path("/posts/:postId")

export const experienceProfilePath = path("/profile/experience")
export const securityPath = path("/profile/security")

export const calendarPath = path("/calendar")
export const operationsPath = path("/operations")
